import { cn } from "../../lib/utils"

interface CheckboxProps {
  checked?: boolean
  onChange?: (checked: boolean) => void
  label?: string
  className?: string
  id?: string
}

export function Checkbox({ checked, onChange, label, className, id }: CheckboxProps) {
  return (
    <div className="flex items-center gap-2">
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={e => onChange?.(e.target.checked)}
        className={cn(
          "w-4 h-4 rounded border-ink-300 dark:border-ink-700 text-brand-700 focus:ring-brand-500 focus:ring-offset-0 bg-white dark:bg-ink-900",
          className
        )}
      />
      {label && (
        <label htmlFor={id} className="text-sm text-ink-700 dark:text-ink-300 cursor-pointer select-none">
          {label}
        </label>
      )}
    </div>
  )
}
